import { Container, Grid, useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import { BREAKPOINTS } from 'configs/Constant';

import HeaderLeft from './components/HeaderLeft';
import HeaderLeftSmartPhone from './components/HeaderLeftSmartPhone';
import HeaderRight from './components/HeaderRight';
import useStyles from './styles';

const Header = ({ wrapHeaderStyle }) => {
  const classes = useStyles();
  const isMobile = useMediaQuery(BREAKPOINTS.mobile);

  return (
    <div className={clsx(classes.wrapHeader, wrapHeaderStyle)}>
      <Container>
        <Grid
          container
          className={classes.row}
        >
          {isMobile && <HeaderLeftSmartPhone />}
          {!isMobile && <HeaderLeft />}
          <HeaderRight />
        </Grid>
      </Container>
    </div>
  );
};

export default Header;
